// // /* ============================================================
// //    CINEMATIC ODYSSEY — motion engine
// //    Progressive enhancement. Content is visible without JS.
// //    GSAP core + ScrollTrigger only (no premium plugins required).
// //    ============================================================ */
// // (function () {
// //   "use strict";

// //   var root = document.documentElement;
// //   var body = document.body;

// //   var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
// //   var motionAllowed = root.dataset.motion === "true" && !prefersReduced;
// //   var cursorAllowed = root.dataset.cursor === "true" && !prefersReduced;
// //   var hasGSAP = typeof window.gsap !== "undefined";

// //   clearTimeout(window.__coFailsafe);

// //   /* Reduced motion must never autoplay ambient video */
// //   if (prefersReduced) {
// //     document.querySelectorAll("video[data-ambient]").forEach(function (v) {
// //       v.removeAttribute("autoplay");
// //       try { v.pause(); v.currentTime = 0; } catch (e) {}
// //     });
// //   }

// //   /* Reading progress — an indicator, not motion; runs in all cases */
// //   (function () {
// //     var bar = document.querySelector("[data-reading-progress]");
// //     if (!bar) return;
// //     function update() {
// //       var max = document.documentElement.scrollHeight - window.innerHeight;
// //       var p = max > 0 ? window.scrollY / max : 0;
// //       bar.style.transform = "scaleX(" + Math.min(1, Math.max(0, p)) + ")";
// //     }
// //     window.addEventListener("scroll", update, { passive: true });
// //     window.addEventListener("resize", update);
// //     update();
// //   })();

// //   /* ---------------------------------------------------- loader */
// //   function hideLoader() {
// //     root.classList.add("co-loaded");
// //     var loader = document.querySelector(".co-loader");
// //     if (!loader) return;
// //     if (hasGSAP && motionAllowed) {
// //       var fill = loader.querySelector(".co-loader__fill");
// //       var tl = gsap.timeline({ onComplete: function () { loader.remove(); } });
// //       if (fill) tl.to(fill, { width: "100%", duration: 0.5, ease: "power2.inOut" });
// //       tl.to(loader, { autoAlpha: 0, duration: 0.7, ease: "power2.inOut" }, "+=0.15");
// //     } else {
// //       loader.style.transition = "opacity .5s ease";
// //       loader.style.opacity = "0";
// //       setTimeout(function () { loader.remove(); }, 520);
// //     }
// //   }

// //   function revealAll() { root.classList.remove("co-anim"); }

// //   /* ---------------------------------------------------- static fallback */
// //   if (!hasGSAP || !motionAllowed) {
// //     revealAll();
// //     window.addEventListener("load", hideLoader);
// //     if (cursorAllowed) initCursor();
// //     return;
// //   }

// //   gsap.registerPlugin(ScrollTrigger);

// //   /* ---------------------------------------------------- line-mask splitter
// //      Wraps words, measures line wraps by offsetTop, regroups into
// //      .co-line rows so each visual line can reveal behind a mask. */
// //   function splitToLines(el) {
// //     if (el.dataset.split === "done") return el.querySelectorAll(".co-word");
// //     var raw = el.textContent.replace(/\s+/g, " ").trim();
// //     var words = raw.split(" ");
// //     el.textContent = "";
// //     var spans = words.map(function (w) {
// //       var s = document.createElement("span");
// //       s.className = "co-word";
// //       s.textContent = w;
// //       el.appendChild(s);
// //       el.appendChild(document.createTextNode(" "));
// //       return s;
// //     });
// //     var lines = [], top = null, group = null;
// //     spans.forEach(function (s) {
// //       var t = s.offsetTop;
// //       if (top === null || Math.abs(t - top) > 2) { group = []; lines.push(group); top = t; }
// //       group.push(s);
// //     });
// //     el.textContent = "";
// //     lines.forEach(function (g) {
// //       var line = document.createElement("span");
// //       line.className = "co-line";
// //       g.forEach(function (s, i) {
// //         line.appendChild(s);
// //         if (i < g.length - 1) line.appendChild(document.createTextNode(" "));
// //       });
// //       el.appendChild(line);
// //     });
// //     el.dataset.split = "done";
// //     return el.querySelectorAll(".co-word");
// //   }

// //   /* ---------------------------------------------------- scene registry */
// //   var scenes = {};
// //   function scene(name, fn) { scenes[name] = fn; }
// //   function initScenes() {
// //     document.querySelectorAll("[data-scene]").forEach(function (el) {
// //       var fn = scenes[el.dataset.scene];
// //       if (fn) { try { fn(el); } catch (e) { /* never let one scene break the rest */ } }
// //     });
// //   }

// //   /* ---------------------------------------------------- generic reveals
// //      For sections that just declare [data-reveal] on children. */
// //   function initReveals() {
// //     document.querySelectorAll('[data-reveal="fade"]').forEach(function (el) {
// //       gsap.to(el, {
// //         opacity: 1, y: 0, duration: 1.1, ease: "power3.out",
// //         scrollTrigger: { trigger: el, start: "top 82%" }
// //       });
// //     });
// //     document.querySelectorAll('[data-reveal="mask"]').forEach(function (el) {
// //       var inner = el.children;
// //       gsap.to(inner, {
// //         yPercent: 0, duration: 1.2, ease: "power4.out", stagger: 0.08,
// //         scrollTrigger: { trigger: el, start: "top 84%" }
// //       });
// //     });
// //   }

// //   /* ---------------------------------------------------- CHAPTER I — Arrival */
// //   scene("arrival", function (el) {
// //     var stage = el.querySelector("[data-arrival-stage]");
// //     var media = el.querySelector("[data-arrival-media]");
// //     var headline = el.querySelector("[data-arrival-headline]");
// //     var fades = el.querySelectorAll("[data-arrival-fade]");
// //     var cue = el.querySelector("[data-arrival-cue]");
// //     var content = el.querySelector("[data-arrival-content]");

// //     var tl = gsap.timeline({ defaults: { ease: "power3.out" } });

// //     if (media) tl.to(media, { scale: 1, duration: 2.6, ease: "power2.out" }, 0);

// //     if (headline) {
// //       var words = splitToLines(headline);
// //       gsap.set(words, { yPercent: 115 });
// //       gsap.set(headline, { opacity: 1 });
// //       tl.to(words, { yPercent: 0, duration: 1.15, stagger: 0.07, ease: "power4.out" }, 0.35);
// //     }
// //     if (fades.length) tl.to(fades, { opacity: 1, y: 0, duration: 1, stagger: 0.12 }, 0.95);
// //     if (cue) tl.to(cue, { opacity: 1, duration: 0.8 }, 1.5);

// //     if (cue) {
// //       var cl = cue.querySelector("[data-cue-line]") || cue;
// //       gsap.to(cl, { yPercent: 55, opacity: 0.2, repeat: -1, yoyo: true, duration: 1.7, ease: "sine.inOut", delay: 2 });
// //     }

// //     /* scroll: gentle continued push (scale-up never exposes edges) + content dim-out */
// //     if (stage) gsap.to(stage, {
// //       scale: 1.06, ease: "none",
// //       scrollTrigger: { trigger: el, start: "top top", end: "bottom top", scrub: true }
// //     });
// //     if (content) gsap.to(content, {
// //       opacity: 0, yPercent: -6, ease: "none",
// //       scrollTrigger: { trigger: el, start: "top top", end: "55% top", scrub: true }
// //     });

// //     if (el.dataset.particles === "true") initParticles(el);
// //   });

// //   /* ---------------------------------------------------- ambient particles */
// //   function initParticles(container) {
// //     var canvas = container.querySelector("[data-particles]");
// //     if (!canvas) return;
// //     var ctx = canvas.getContext("2d");
// //     var dpr = Math.min(window.devicePixelRatio || 1, 2);
// //     var w = 0, h = 0, parts = [];
// //     var champagne = getComputedStyle(root).getPropertyValue("--co-champagne").trim() || "#C6A867";

// //     function resize() {
// //       w = container.offsetWidth; h = container.offsetHeight;
// //       canvas.width = w * dpr; canvas.height = h * dpr;
// //       canvas.style.width = w + "px"; canvas.style.height = h + "px";
// //       ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
// //     }
// //     function seed() {
// //       var count = Math.min(46, Math.round((w * h) / 27000));
// //       parts = [];
// //       for (var i = 0; i < count; i++) parts.push({
// //         x: Math.random() * w, y: Math.random() * h,
// //         r: Math.random() * 1.5 + 0.4,
// //         vx: (Math.random() - 0.5) * 0.1,
// //         vy: -(Math.random() * 0.16 + 0.03),
// //         a: Math.random() * 0.35 + 0.08
// //       });
// //     }
// //     function tick() {
// //       ctx.clearRect(0, 0, w, h);
// //       ctx.fillStyle = champagne;
// //       for (var i = 0; i < parts.length; i++) {
// //         var p = parts[i];
// //         p.x += p.vx; p.y += p.vy;
// //         if (p.y < -12) { p.y = h + 12; p.x = Math.random() * w; }
// //         if (p.x < -12) p.x = w + 12; else if (p.x > w + 12) p.x = -12;
// //         ctx.globalAlpha = p.a;
// //         ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
// //       }
// //       ctx.globalAlpha = 1;
// //     }
// //     resize(); seed();
// //     gsap.ticker.add(tick);
// //     if (window.ResizeObserver) new ResizeObserver(function () { resize(); seed(); }).observe(container);
// //   }

// //   /* ---------------------------------------------------- cinematic cursor */
// //   function initCursor() {
// //     if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
// //     var cursor = document.querySelector(".co-cursor");
// //     if (!cursor) return;
// //     var ring = cursor.querySelector(".co-cursor__ring");
// //     var dot = cursor.querySelector(".co-cursor__dot");
// //     body.classList.add("co-cursor-active");

// //     var x = window.innerWidth / 2, y = window.innerHeight / 2;
// //     window.addEventListener("mousemove", function (e) { x = e.clientX; y = e.clientY; }, { passive: true });

// //     if (hasGSAP) {
// //       var rx = gsap.quickTo(ring, "x", { duration: 0.5, ease: "power3" });
// //       var ry = gsap.quickTo(ring, "y", { duration: 0.5, ease: "power3" });
// //       var dx = gsap.quickTo(dot, "x", { duration: 0.1, ease: "power3" });
// //       var dy = gsap.quickTo(dot, "y", { duration: 0.1, ease: "power3" });
// //       gsap.ticker.add(function () { rx(x); ry(y); dx(x); dy(y); });
// //     }
// //     document.querySelectorAll("a, button, [data-cursor='grow']").forEach(function (elx) {
// //       elx.addEventListener("mouseenter", function () { body.classList.add("co-hovering"); });
// //       elx.addEventListener("mouseleave", function () { body.classList.remove("co-hovering"); });
// //     });
// //   }

// //   /* ---------------------------------------------------- boot */
// //   function start() {
// //     initScenes();
// //     initReveals();
// //     ScrollTrigger.refresh();
// //   }
// //   if (document.fonts && document.fonts.ready) document.fonts.ready.then(start);
// //   else start();

// //   window.addEventListener("load", function () { hideLoader(); ScrollTrigger.refresh(); });
// //   if (cursorAllowed) initCursor();

// //   /* Shopify Theme Editor: re-init when sections are added/reordered */
// //   document.addEventListener("shopify:section:load", function () { ScrollTrigger.refresh(); });
// // })();



// /* ============================================================
//    CINEMATIC ODYSSEY — motion engine
//    Progressive enhancement. Content is visible without JS.
//    GSAP core + ScrollTrigger only (no premium plugins required).
//    ============================================================ */
// (function () {
//   "use strict";

//   var root = document.documentElement;
//   var body = document.body;

//   var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
//   var motionAllowed = root.dataset.motion === "true" && !prefersReduced;
//   var cursorAllowed = root.dataset.cursor === "true" && !prefersReduced;
//   var hasGSAP = typeof window.gsap !== "undefined";

//   clearTimeout(window.__coFailsafe);

//   /* Reduced motion must never autoplay ambient video */
//   if (prefersReduced) {
//     document.querySelectorAll("video[data-ambient]").forEach(function (v) {
//       v.removeAttribute("autoplay");
//       try { v.pause(); v.currentTime = 0; } catch (e) {}
//     });
//   }

//   /* Reading progress — an indicator, not motion; runs in all cases */
//   (function () {
//     var bar = document.querySelector("[data-reading-progress]");
//     if (!bar) return;
//     function update() {
//       var max = document.documentElement.scrollHeight - window.innerHeight;
//       var p = max > 0 ? window.scrollY / max : 0;
//       bar.style.transform = "scaleX(" + Math.min(1, Math.max(0, p)) + ")";
//     }
//     window.addEventListener("scroll", update, { passive: true });
//     window.addEventListener("resize", update);
//     update();
//   })();

//   /* ---------------------------------------------------- loader */
//   function hideLoader() {
//     root.classList.add("co-loaded");
//     var loader = document.querySelector(".co-loader");
//     if (!loader) return;
//     if (hasGSAP && motionAllowed) {
//       var fill = loader.querySelector(".co-loader__fill");
//       var tl = gsap.timeline({ onComplete: function () { loader.remove(); } });
//       if (fill) tl.to(fill, { width: "100%", duration: 0.5, ease: "power2.inOut" });
//       tl.to(loader, { autoAlpha: 0, duration: 0.7, ease: "power2.inOut" }, "+=0.15");
//     } else {
//       loader.style.transition = "opacity .5s ease";
//       loader.style.opacity = "0";
//       setTimeout(function () { loader.remove(); }, 520);
//     }
//   }

//   function revealAll() { root.classList.remove("co-anim"); }

//   /* ---------------------------------------------------- static fallback */
//   if (!hasGSAP || !motionAllowed) {
//     revealAll();
//     window.addEventListener("load", hideLoader);
//     if (cursorAllowed) initCursor();
//     return;
//   }

//   gsap.registerPlugin(ScrollTrigger);

//   /* ---------------------------------------------------- line-mask splitter
//      Wraps words, measures line wraps by offsetTop, regroups into
//      .co-line rows so each visual line can reveal behind a mask. */
//   function splitToLines(el) {
//     if (el.dataset.split === "done") return el.querySelectorAll(".co-word");
//     var raw = el.textContent.replace(/\s+/g, " ").trim();
//     var words = raw.split(" ");
//     el.textContent = "";
//     var spans = words.map(function (w) {
//       var s = document.createElement("span");
//       s.className = "co-word";
//       s.textContent = w;
//       el.appendChild(s);
//       el.appendChild(document.createTextNode(" "));
//       return s;
//     });
//     var lines = [], top = null, group = null;
//     spans.forEach(function (s) {
//       var t = s.offsetTop;
//       if (top === null || Math.abs(t - top) > 2) { group = []; lines.push(group); top = t; }
//       group.push(s);
//     });
//     el.textContent = "";
//     lines.forEach(function (g) {
//       var line = document.createElement("span");
//       line.className = "co-line";
//       g.forEach(function (s, i) {
//         line.appendChild(s);
//         if (i < g.length - 1) line.appendChild(document.createTextNode(" "));
//       });
//       el.appendChild(line);
//     });
//     el.dataset.split = "done";
//     return el.querySelectorAll(".co-word");
//   }

//   /* ---------------------------------------------------- scene registry */
//   var scenes = {};
//   function scene(name, fn) { scenes[name] = fn; }
//   function initScenes() {
//     document.querySelectorAll("[data-scene]").forEach(function (el) {
//       var fn = scenes[el.dataset.scene];
//       if (fn) { try { fn(el); } catch (e) { /* never let one scene break the rest */ } }
//     });
//   }

//   /* ---------------------------------------------------- generic reveals
//      For sections that just declare [data-reveal] on children.
//      Uses fromTo so the hidden state is inline (survives without co-anim). */
//   function initReveals(scope) {
//     scope = scope || document;
//     scope.querySelectorAll('[data-reveal="fade"]').forEach(function (el) {
//       gsap.fromTo(el, { opacity: 0, y: 24 }, {
//         opacity: 1, y: 0, duration: 1.1, ease: "power3.out",
//         scrollTrigger: { trigger: el, start: "top 82%" }
//       });
//     });
//     scope.querySelectorAll('[data-reveal="mask"]').forEach(function (el) {
//       gsap.fromTo(el.children, { yPercent: 110 }, {
//         yPercent: 0, duration: 1.2, ease: "power4.out", stagger: 0.08,
//         scrollTrigger: { trigger: el, start: "top 84%" }
//       });
//     });
//   }

//   /* ---------------------------------------------------- CHAPTER I — Arrival */
//   scene("arrival", function (el) {
//     var stage = el.querySelector("[data-arrival-stage]");
//     var media = el.querySelector("[data-arrival-media]");
//     var headline = el.querySelector("[data-arrival-headline]");
//     var fades = el.querySelectorAll("[data-arrival-fade]");
//     var cue = el.querySelector("[data-arrival-cue]");
//     var content = el.querySelector("[data-arrival-content]");

//     var tl = gsap.timeline({ defaults: { ease: "power3.out" } });

//     if (media) {
//       gsap.set(media, { scale: 1.18 });
//       tl.to(media, { scale: 1, duration: 2.6, ease: "power2.out" }, 0);
//     }

//     if (headline) {
//       var words = splitToLines(headline);
//       gsap.set(headline, { opacity: 1 });
//       gsap.set(words, { yPercent: 115 });
//       tl.to(words, { yPercent: 0, duration: 1.15, stagger: 0.07, ease: "power4.out" }, 0.35);
//     }
//     if (fades.length) {
//       gsap.set(fades, { opacity: 0, y: 20 });
//       tl.to(fades, { opacity: 1, y: 0, duration: 1, stagger: 0.12 }, 0.95);
//     }
//     if (cue) {
//       gsap.set(cue, { opacity: 0 });
//       tl.to(cue, { opacity: 1, duration: 0.8 }, 1.5);
//     }

//     if (cue) {
//       var cl = cue.querySelector("[data-cue-line]") || cue;
//       gsap.to(cl, { yPercent: 55, opacity: 0.2, repeat: -1, yoyo: true, duration: 1.7, ease: "sine.inOut", delay: 2 });
//     }

//     /* scroll: gentle continued push (scale-up never exposes edges) + content dim-out */
//     if (stage) gsap.to(stage, {
//       scale: 1.06, ease: "none",
//       scrollTrigger: { trigger: el, start: "top top", end: "bottom top", scrub: true }
//     });
//     if (content) gsap.to(content, {
//       opacity: 0, yPercent: -6, ease: "none",
//       scrollTrigger: { trigger: el, start: "top top", end: "55% top", scrub: true }
//     });

//     if (el.dataset.particles === "true") initParticles(el);
//   });

//   /* ---------------------------------------------------- ambient particles */
//   function initParticles(container) {
//     var canvas = container.querySelector("[data-particles]");
//     if (!canvas) return;
//     var ctx = canvas.getContext("2d");
//     var dpr = Math.min(window.devicePixelRatio || 1, 2);
//     var w = 0, h = 0, parts = [];
//     var champagne = getComputedStyle(root).getPropertyValue("--co-champagne").trim() || "#C6A867";

//     function resize() {
//       w = container.offsetWidth; h = container.offsetHeight;
//       canvas.width = w * dpr; canvas.height = h * dpr;
//       canvas.style.width = w + "px"; canvas.style.height = h + "px";
//       ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
//     }
//     function seed() {
//       var count = Math.min(46, Math.round((w * h) / 27000));
//       parts = [];
//       for (var i = 0; i < count; i++) parts.push({
//         x: Math.random() * w, y: Math.random() * h,
//         r: Math.random() * 1.5 + 0.4,
//         vx: (Math.random() - 0.5) * 0.1,
//         vy: -(Math.random() * 0.16 + 0.03),
//         a: Math.random() * 0.35 + 0.08
//       });
//     }
//     function tick() {
//       ctx.clearRect(0, 0, w, h);
//       ctx.fillStyle = champagne;
//       for (var i = 0; i < parts.length; i++) {
//         var p = parts[i];
//         p.x += p.vx; p.y += p.vy;
//         if (p.y < -12) { p.y = h + 12; p.x = Math.random() * w; }
//         if (p.x < -12) p.x = w + 12; else if (p.x > w + 12) p.x = -12;
//         ctx.globalAlpha = p.a;
//         ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
//       }
//       ctx.globalAlpha = 1;
//     }
//     resize(); seed();
//     gsap.ticker.add(tick);
//     if (window.ResizeObserver) new ResizeObserver(function () { resize(); seed(); }).observe(container);
//   }

//   /* ---------------------------------------------------- cinematic cursor */
//   function initCursor() {
//     if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
//     var cursor = document.querySelector(".co-cursor");
//     if (!cursor) return;
//     var ring = cursor.querySelector(".co-cursor__ring");
//     var dot = cursor.querySelector(".co-cursor__dot");
//     body.classList.add("co-cursor-active");

//     var x = window.innerWidth / 2, y = window.innerHeight / 2;
//     window.addEventListener("mousemove", function (e) { x = e.clientX; y = e.clientY; }, { passive: true });

//     if (hasGSAP) {
//       var rx = gsap.quickTo(ring, "x", { duration: 0.5, ease: "power3" });
//       var ry = gsap.quickTo(ring, "y", { duration: 0.5, ease: "power3" });
//       var dx = gsap.quickTo(dot, "x", { duration: 0.1, ease: "power3" });
//       var dy = gsap.quickTo(dot, "y", { duration: 0.1, ease: "power3" });
//       gsap.ticker.add(function () { rx(x); ry(y); dx(x); dy(y); });
//     }
//     document.querySelectorAll("a, button, [data-cursor='grow']").forEach(function (elx) {
//       elx.addEventListener("mouseenter", function () { body.classList.add("co-hovering"); });
//       elx.addEventListener("mouseleave", function () { body.classList.remove("co-hovering"); });
//     });
//   }

//   /* ---------------------------------------------------- boot */
//   function start() {
//     initScenes();
//     initReveals(document);
//     ScrollTrigger.refresh();
//     /* Setup done: all hidden-states are now inline GSAP values, so lifting
//        the CSS pre-hide can never trap content invisible. */
//     revealAll();
//   }
//   var booted = false;
//   function boot() { if (booted) return; booted = true; start(); }
//   if (document.fonts && document.fonts.ready) {
//     document.fonts.ready.then(boot);
//     setTimeout(boot, 1500); /* never wait forever on font loading */
//   } else {
//     boot();
//   }

//   window.addEventListener("load", function () { hideLoader(); ScrollTrigger.refresh(); });
//   if (cursorAllowed) initCursor();

//   /* Shopify Theme Editor: fully re-init the section that reloaded. */
//   document.addEventListener("shopify:section:load", function (e) {
//     var scope = e.target;
//     if (!scope || !scope.querySelectorAll) return;
//     /* clear stale triggers inside this section to avoid duplicates */
//     ScrollTrigger.getAll().forEach(function (t) {
//       if (t.trigger && scope.contains(t.trigger)) t.kill();
//     });
//     scope.querySelectorAll("[data-scene]").forEach(function (el) {
//       var fn = scenes[el.dataset.scene];
//       if (fn) { try { fn(el); } catch (err) {} }
//     });
//     initReveals(scope);
//     ScrollTrigger.refresh();
//   });
// })();



/* ============================================================
   CINEMATIC ODYSSEY — motion engine
   Progressive enhancement. Content is visible without JS.
   GSAP core + ScrollTrigger only (no premium plugins required).
   ============================================================ */
(function () {
  "use strict";

  var root = document.documentElement;
  var body = document.body;

  var prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var motionAllowed = root.dataset.motion === "true" && !prefersReduced;
  var cursorAllowed = root.dataset.cursor === "true" && !prefersReduced;
  var hasGSAP = typeof window.gsap !== "undefined";

  /* NOTE: we intentionally do NOT clear window.__coFailsafe here.
     The 4.5s failsafe in theme.liquid stays armed as a guaranteed backstop —
     if anything below throws, co-anim is still removed and nothing is trapped.
     revealAll() below removes it earlier on the happy path anyway. */

  /* Reduced motion must never autoplay ambient video */
  if (prefersReduced) {
    document.querySelectorAll("video[data-ambient]").forEach(function (v) {
      v.removeAttribute("autoplay");
      try { v.pause(); v.currentTime = 0; } catch (e) {}
    });
  }

  /* Reading progress — an indicator, not motion; runs in all cases */
  (function () {
    var bar = document.querySelector("[data-reading-progress]");
    if (!bar) return;
    function update() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var p = max > 0 ? window.scrollY / max : 0;
      bar.style.transform = "scaleX(" + Math.min(1, Math.max(0, p)) + ")";
    }
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  })();

  /* ---------------------------------------------------- loader */
  function hideLoader() {
    root.classList.add("co-loaded");
    var loader = document.querySelector(".co-loader");
    if (!loader) return;
    if (hasGSAP && motionAllowed) {
      var fill = loader.querySelector(".co-loader__fill");
      var tl = gsap.timeline({ onComplete: function () { loader.remove(); } });
      if (fill) tl.to(fill, { width: "100%", duration: 0.5, ease: "power2.inOut" });
      tl.to(loader, { autoAlpha: 0, duration: 0.7, ease: "power2.inOut" }, "+=0.15");
    } else {
      loader.style.transition = "opacity .5s ease";
      loader.style.opacity = "0";
      setTimeout(function () { loader.remove(); }, 520);
    }
  }

  function revealAll() { root.classList.remove("co-anim"); }

  /* ---------------------------------------------------- static fallback */
  if (!hasGSAP || !motionAllowed) {
    revealAll();
    window.addEventListener("load", hideLoader);
    if (cursorAllowed) initCursor();
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  /* ---------------------------------------------------- line-mask splitter
     Wraps words, measures line wraps by offsetTop, regroups into
     .co-line rows so each visual line can reveal behind a mask. */
  function splitToLines(el) {
    if (el.dataset.split === "done") return el.querySelectorAll(".co-word");
    var raw = el.textContent.replace(/\s+/g, " ").trim();
    var words = raw.split(" ");
    el.textContent = "";
    var spans = words.map(function (w) {
      var s = document.createElement("span");
      s.className = "co-word";
      s.textContent = w;
      el.appendChild(s);
      el.appendChild(document.createTextNode(" "));
      return s;
    });
    var lines = [], top = null, group = null;
    spans.forEach(function (s) {
      var t = s.offsetTop;
      if (top === null || Math.abs(t - top) > 2) { group = []; lines.push(group); top = t; }
      group.push(s);
    });
    el.textContent = "";
    lines.forEach(function (g) {
      var line = document.createElement("span");
      line.className = "co-line";
      g.forEach(function (s, i) {
        line.appendChild(s);
        if (i < g.length - 1) line.appendChild(document.createTextNode(" "));
      });
      el.appendChild(line);
    });
    el.dataset.split = "done";
    return el.querySelectorAll(".co-word");
  }

  /* ---------------------------------------------------- scene registry */
  var scenes = {};
  function scene(name, fn) { scenes[name] = fn; }
  function initScenes() {
    document.querySelectorAll("[data-scene]").forEach(function (el) {
      var fn = scenes[el.dataset.scene];
      if (fn) { try { fn(el); } catch (e) { /* never let one scene break the rest */ } }
    });
  }

  /* ---------------------------------------------------- generic reveals
     For sections that just declare [data-reveal] on children.
     Uses fromTo so the hidden state is inline (survives without co-anim). */
  function initReveals(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-reveal="fade"]').forEach(function (el) {
      gsap.fromTo(el, { opacity: 0, y: 24 }, {
        opacity: 1, y: 0, duration: 1.1, ease: "power3.out",
        scrollTrigger: { trigger: el, start: "top 82%" }
      });
    });
    scope.querySelectorAll('[data-reveal="mask"]').forEach(function (el) {
      gsap.fromTo(el.children, { yPercent: 110 }, {
        yPercent: 0, duration: 1.2, ease: "power4.out", stagger: 0.08,
        scrollTrigger: { trigger: el, start: "top 84%" }
      });
    });
  }

  /* ---------------------------------------------------- CHAPTER I — Arrival */
  scene("arrival", function (el) {
    var stage = el.querySelector("[data-arrival-stage]");
    var media = el.querySelector("[data-arrival-media]");
    var headline = el.querySelector("[data-arrival-headline]");
    var fades = el.querySelectorAll("[data-arrival-fade]");
    var cue = el.querySelector("[data-arrival-cue]");
    var content = el.querySelector("[data-arrival-content]");

    var tl = gsap.timeline({ defaults: { ease: "power3.out" } });

    if (media) {
      gsap.set(media, { scale: 1.18 });
      tl.to(media, { scale: 1, duration: 2.6, ease: "power2.out" }, 0);
    }

    if (headline) {
      /* Simple, robust reveal — no DOM surgery, cannot trap the headline.
         fromTo (immediateRender) hides it inline only while JS is active;
         if this never runs, the headline stays plainly visible. */
      tl.fromTo(headline,
        { opacity: 0, y: 42 },
        { opacity: 1, y: 0, duration: 1.25, ease: "power4.out" },
        0.3);
    }
    if (fades.length) {
      gsap.set(fades, { opacity: 0, y: 20 });
      tl.to(fades, { opacity: 1, y: 0, duration: 1, stagger: 0.12 }, 0.95);
    }
    if (cue) {
      gsap.set(cue, { opacity: 0 });
      tl.to(cue, { opacity: 1, duration: 0.8 }, 1.5);
    }

    if (cue) {
      var cl = cue.querySelector("[data-cue-line]") || cue;
      gsap.to(cl, { yPercent: 55, opacity: 0.2, repeat: -1, yoyo: true, duration: 1.7, ease: "sine.inOut", delay: 2 });
    }

    /* scroll: gentle continued push (scale-up never exposes edges) + content dim-out */
    if (stage) gsap.to(stage, {
      scale: 1.06, ease: "none",
      scrollTrigger: { trigger: el, start: "top top", end: "bottom top", scrub: true }
    });
    if (content) gsap.to(content, {
      opacity: 0, yPercent: -6, ease: "none",
      scrollTrigger: { trigger: el, start: "top top", end: "55% top", scrub: true }
    });

    if (el.dataset.particles === "true") initParticles(el);
  });

  /* ---------------------------------------------------- ambient particles */
  function initParticles(container) {
    var canvas = container.querySelector("[data-particles]");
    if (!canvas) return;
    var ctx = canvas.getContext("2d");
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0, parts = [];
    var champagne = getComputedStyle(root).getPropertyValue("--co-champagne").trim() || "#C6A867";

    function resize() {
      w = container.offsetWidth; h = container.offsetHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      canvas.style.width = w + "px"; canvas.style.height = h + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function seed() {
      var count = Math.min(46, Math.round((w * h) / 27000));
      parts = [];
      for (var i = 0; i < count; i++) parts.push({
        x: Math.random() * w, y: Math.random() * h,
        r: Math.random() * 1.5 + 0.4,
        vx: (Math.random() - 0.5) * 0.1,
        vy: -(Math.random() * 0.16 + 0.03),
        a: Math.random() * 0.35 + 0.08
      });
    }
    function tick() {
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = champagne;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.x += p.vx; p.y += p.vy;
        if (p.y < -12) { p.y = h + 12; p.x = Math.random() * w; }
        if (p.x < -12) p.x = w + 12; else if (p.x > w + 12) p.x = -12;
        ctx.globalAlpha = p.a;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }
    resize(); seed();
    gsap.ticker.add(tick);
    if (window.ResizeObserver) new ResizeObserver(function () { resize(); seed(); }).observe(container);
  }

  /* ---------------------------------------------------- cinematic cursor */
  function initCursor() {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    var cursor = document.querySelector(".co-cursor");
    if (!cursor) return;
    var ring = cursor.querySelector(".co-cursor__ring");
    var dot = cursor.querySelector(".co-cursor__dot");
    body.classList.add("co-cursor-active");

    var x = window.innerWidth / 2, y = window.innerHeight / 2;
    window.addEventListener("mousemove", function (e) { x = e.clientX; y = e.clientY; }, { passive: true });

    if (hasGSAP) {
      var rx = gsap.quickTo(ring, "x", { duration: 0.5, ease: "power3" });
      var ry = gsap.quickTo(ring, "y", { duration: 0.5, ease: "power3" });
      var dx = gsap.quickTo(dot, "x", { duration: 0.1, ease: "power3" });
      var dy = gsap.quickTo(dot, "y", { duration: 0.1, ease: "power3" });
      gsap.ticker.add(function () { rx(x); ry(y); dx(x); dy(y); });
    }
    document.querySelectorAll("a, button, [data-cursor='grow']").forEach(function (elx) {
      elx.addEventListener("mouseenter", function () { body.classList.add("co-hovering"); });
      elx.addEventListener("mouseleave", function () { body.classList.remove("co-hovering"); });
    });
  }

  /* ---------------------------------------------------- boot */
  function start() {
    initScenes();
    initReveals(document);
    ScrollTrigger.refresh();
    /* Setup done: all hidden-states are now inline GSAP values, so lifting
       the CSS pre-hide can never trap content invisible. */
    revealAll();
  }
  var booted = false;
  function boot() { if (booted) return; booted = true; start(); }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(boot);
    setTimeout(boot, 1500); /* never wait forever on font loading */
  } else {
    boot();
  }

  window.addEventListener("load", function () { hideLoader(); ScrollTrigger.refresh(); });
  if (cursorAllowed) initCursor();

  /* Shopify Theme Editor: fully re-init the section that reloaded. */
  document.addEventListener("shopify:section:load", function (e) {
    var scope = e.target;
    if (!scope || !scope.querySelectorAll) return;
    /* clear stale triggers inside this section to avoid duplicates */
    ScrollTrigger.getAll().forEach(function (t) {
      if (t.trigger && scope.contains(t.trigger)) t.kill();
    });
    scope.querySelectorAll("[data-scene]").forEach(function (el) {
      var fn = scenes[el.dataset.scene];
      if (fn) { try { fn(el); } catch (err) {} }
    });
    initReveals(scope);
    ScrollTrigger.refresh();
  });
})();
